import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../index";
import { SearchState } from "./types";

const slice = (state: RootState) => state.search;

export const selectSearchLoading = createSelector(slice, (state: SearchState) => state.loading);
export const selectSearchQuery = createSelector(slice, (state: SearchState) => state.query);
export const selectSearchResult = createSelector(slice, (state: SearchState) => state.result);
